



























































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";

import MyForm from "@/mixins/form";

@Component
export default class extends Mixins(MyForm) {
  @Prop() stadiumId!: number;

  handleSubmit(e: any) {
    e.preventDefault();
    this.form.validateFields((err: any, values: any) => {
      if (!err) {
        this.$confirm({
          title: "确认信息",
          content: "确定要提交吗？",
          onOk: async () => {
            const res = await this.$store.dispatch("stadium/saveExpense", {
              stadium_id: this.stadiumId,
              ...values
            });
            if (res && res.Message && res.Message === "success") {
              this.$message.success(res.Message);
              this.loadData1();
            } else {
              this.$message.error(res.Message);
            }
          }
        });
      }
    });
  }

  mounted() {
    this.loadData1();
  }

  async loadData1() {
    const res = await this.$store.dispatch("stadium/getExpense", {
      stadium_id: this.stadiumId
    });
    if (res && res.Data && res.Data !== "{}") {
      this.formData = res.Data;
    }
  }
}
